import React, {Component, useState} from 'react';
import { Button, Container, Row, Col, FormControl, FormLabel, Alert } from 'react-bootstrap';
import UOMDataService from "./services/uom.service";
import { Navigate } from 'react-router-dom';
import { IoIosArrowBack } from "react-icons/io";

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class NewUOM extends Component {  

  constructor(props) {
    super(props);
    this.onChangeUOMAbbrev = this.onChangeUOMAbbrev.bind(this);
    this.onChangeUOMLongDescription = this.onChangeUOMLongDescription.bind(this);
    this.saveUOM = this.saveUOM.bind(this);
    this.retrieveUOMs = this.retrieveUOMs.bind(this);
    this.refreshList = this.refreshList.bind(this);    
    this.handleValidations = this.handleValidations.bind(this);
    this.goToUOMsList = this.goToUOMsList.bind(this);

    this.state = {
      id: null,
      unitofmeasureabbrev: "",
      unitofmeasurelongdescription: "",
      submitted: false,
      UOMs: [],
      currentUOM: null,
      currentIndex: -1,  
      showerror: false,
      errmessage:'',   
      showsuccess: false,
      succmessage: ''
    };
  }

  goToUOMsList() {
    window.location.assign('/uoms');
  }

  handleValidations() {
    if (this.state.unitofmeasureabbrev.length==0) {
      this.setState({errmessage:'Fields can not be empty.'})
      this.setState({showerror:true})
      return;
    }
    this.saveUOM();
  } 

  retrieveUOMs() {
    UOMDataService.getAll()
      .then(response => {
        this.setState({
            UOMs: response.data
        });
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  }

  refreshList() {
    this.retrieveUOMs();
    this.setState({
        currentUOM: null,
        currentIndex: -1
    });
  }

  onChangeUOMAbbrev(e) {
    this.setState({
        unitofmeasureabbrev: e.target.value
    });
  }

  onChangeUOMLongDescription(e) {
    this.setState({
        unitofmeasurelongdescription: e.target.value
    });
  } 

  saveUOM() {
    var data = {
        unitofmeasureabbrev: this.state.unitofmeasureabbrev,
        unitofmeasurelongdescription: this.state.unitofmeasurelongdescription
    };

    UOMDataService.create(data)
      .then(response => {
        this.setState({
          // id: response.data.id,
          unitofmeasureabbrev: response.data.unitofmeasureabbrev,
          unitofmeasurelongdescription: response.data.unitofmeasurelongdescription,
          submitted: true          
        });
        this.setState({errmessage:''});
        this.setState({showerror:false});
        this.setState({succmessage:'UOM has been created. Redirecting to uom list...'});
        this.setState({showsuccess:true});           
        this.refreshList();
        console.log(response.data);
      })
      .catch(e => {
        this.setState({errmessage:e.response?e.response.data.message:e.message})       
        this.setState({showerror:true})
        this.setState({succmessage:''})
        this.setState({showsuccess:false}) 
      });
  }

  render() {
    return (
      <>
      <Container style={{width:"80%"}}>
        <Row className='mb-2'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h1 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>New UOM</h1>
          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>UOM Abbreviation:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="unitofmeasureabbrev" id="unitofmeasureabbrev" onChange={this.onChangeUOMAbbrev}></FormControl>
          </Col>

          <Col className='col-md-3' sm={8}>
            <FormLabel className='mb-2'>UOM Long Description:</FormLabel>       
            <FormControl style={{maxWidth:"300px"}} type="text" name="unitofmeasurelongdescription" id="unitofmeasurelongdescription" onChange={this.onChangeUOMLongDescription}></FormControl>
          </Col>          

        </Row>
        <hr/>
        <Row className='mb-2'>
          <Col className='col-md-3'>
            <Button id='saveItem' onClick={this.handleValidations}>Save UOM</Button>            
            <Button className='m-2' id='backToUOMsList' onClick={this.goToUOMsList}><IoIosArrowBack/></Button>            
          </Col>
        </Row>  
        {this.state.showerror && (
          <Alert variant="danger" onClose={() => this.setState({showerror:false})} dismissible>
            <Alert.Heading>Error</Alert.Heading>
            <p>{this.state.errmessage}</p>
          </Alert>      
        )}
        {this.state.showsuccess && (
          <Alert variant="success" onClose={() => this.setState({showsuccess:false})} dismissible>
            <Alert.Heading>Done</Alert.Heading>
            <p>{this.state.succmessage}</p>
          </Alert>      
        )}     
         { this.state.submitted ? (<Navigate push to="/uoms"/>) : null }                                     
      </Container>
      </>
    )      
  }
}

export default NewUOM;